(function(){
  function init(root){
    if(!root || root.dataset.otrInit) return;
    root.dataset.otrInit = '1';
    var PER   = parseInt(root.dataset.per, 10) || 6;
    var TOTAL = parseInt(root.dataset.total, 10) || 0;
    var grid  = root.querySelector('[data-otr-grid]');
    var cards = [].slice.call(root.querySelectorAll('[data-otr-card]'));
    var more  = root.querySelector('[data-otr-more]');
    var empty = root.querySelector('[data-otr-empty]');
    var count = root.querySelector('[data-otr-count]');
    var fSel  = root.querySelector('[data-otr-filter]');
    var sSel  = root.querySelector('[data-otr-sort]');
    var wBtn  = root.querySelector('[data-otr-write]');
    var form  = root.querySelector('[data-otr-form]');
    var shown = PER;
    function matched(){
      var f = parseInt(fSel.value, 10) || 0;
      return cards.filter(function(c){ return !f || parseInt(c.dataset.rating, 10) === f; });
    }
    function sortCards(list){
      var mode = sSel.value, out = list.slice();
      if(mode === 'high') out.sort(function(a,b){ return b.dataset.rating - a.dataset.rating; });
      else if(mode === 'low') out.sort(function(a,b){ return a.dataset.rating - b.dataset.rating; });
      else out.sort(function(a,b){ return (b.dataset.date||'').localeCompare(a.dataset.date||''); });
      return out;
    }
    function render(){
      var list = sortCards(matched());
      cards.forEach(function(c){ c.hidden = true; });
      list.forEach(function(c, i){ if(i < shown){ c.hidden = false; grid.appendChild(c); } });
      more.hidden  = list.length <= shown;
      empty.hidden = list.length !== 0;
      if(count){
        var f = parseInt(fSel.value, 10) || 0;
        count.textContent = f ? (list.length + '件を表示中') : (TOTAL.toLocaleString() + '件のレビュー');
      }
    }
    more.addEventListener('click', function(){ shown += PER; render(); });
    fSel.addEventListener('change', function(){ shown = PER; render(); });
    sSel.addEventListener('change', function(){ shown = PER; render(); });
    wBtn.addEventListener('click', function(){
      form.hidden = !form.hidden;
      if(!form.hidden) form.scrollIntoView({behavior:'smooth', block:'center'});
    });
    if(location.hash.indexOf('contact_posted') > -1) form.hidden = false;
    render();
  }
  function boot(){ document.querySelectorAll('[data-otr-root]').forEach(init); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
